import { useFormikContext } from 'formik';
import { useMemo } from 'react';
import { Input } from 'ui-components';
import {
  AvatarWithUpload,
  TalentValues,
} from '~/screens/AddTalent/ProfileInformation';

export const NameAndAvatar: React.FC = () => {
  const { values } = useFormikContext<TalentValues>();

  const sPFirstNameLoading =
    !values.firstName && values.smartData?.firstName?.status === 'pending';
  const sPLastNameLoading =
    !values.lastName && values.smartData?.lastName?.status === 'pending';

  const isFirstNameSmart = useMemo(
    () =>
      values.firstName
        ? values.smartData?.firstName?.value === values.firstName
        : false,
    [values.firstName, values.smartData?.firstName?.value],
  );
  const isLastNameSmart = useMemo(
    () =>
      values.lastName
        ? values.smartData?.lastName?.value === values.lastName
        : false,
    [values.smartData?.lastName?.value, values.lastName],
  );

  const { avatar } = values;
  return (
    <div className="flex gap-6">
      <AvatarWithUpload pic={avatar as string} />
      <Input
        isRequired
        label="First Name"
        name="firstName"
        type="text"
        flex={1}
        testId="creator-profile-first-name"
        isSmartData={isFirstNameSmart || sPFirstNameLoading}
        isLoading={sPFirstNameLoading}
        trackId="foam-add-talent-profile-info-first-name"
        clearButtonProps={{
          trackId: 'foam-add-talent-profile-info-first-name-clear',
          'aria-label': 'Clear first name',
        }}
      />
      <Input
        label="Last Name"
        type="text"
        name="lastName"
        flex={1}
        testId="creator-profile-last-name"
        isSmartData={isLastNameSmart || sPLastNameLoading}
        isLoading={sPLastNameLoading}
        trackId="foam-add-talent-profile-info-last-name"
        clearButtonProps={{
          trackId: 'foam-add-talent-profile-info-last-name-clear',
          'aria-label': 'Clear last name',
        }}
        // Todo: Remove pt="5px" when ui-components fix the issue of occupying extra space when isRequired is given in prop
        // https://whalar.atlassian.net/browse/FOAM-10320
        pt="5px"
      />
    </div>
  );
};
